module.exports = __webpack_public_path__ + "img/cn-stu-1.42e329ac.png";